import * as Yup from 'yup';
export const schema = Yup.object().shape({
  price: Yup.number()
    .required('شروع قیمت ضروری می باشد.')
    .typeError('مقدار عددی وارد نمایید.'),
  min_price: Yup.number()
    .required('حداقل قیمت ضروری می باشد.')
    .typeError('مقدار عددی وارد نمایید.'),
  duration: Yup.number()
    .required('مدت زمان حراجی ضروری می باشد.')
    .typeError('مقدار عددی وارد نمایید.'),
  decline_rate: Yup.number()
    .required('روند کاهش قیمت ضروری می باشد.')
    .typeError('مقدار عددی وارد نمایید.'),
});
